import Image from 'components/Image';
import React from 'react';
import ChevronIcon from 'reusable-components/icons/fullcolor/ChevronIcon';
import StarIcon from 'reusable-components/icons/fullcolor/StarIcon';

const CSS = require('./FormExperienceHeader.module.scss');

const IMAGE_OPTIONS = {
  height: 96,
  width: 80,
};

const AVATAR_OPTIONS = {
  height: 40,
  width: 32,
};

interface FormExperienceHeaderProps {
  title: string;
  rating: number;
  nrOfReviews: number;
  experienceImage: string;
  localName: string;
  localImage: string;
  nrOfOtherLocals: number;
  isLocalPicker: boolean;
  onBack?: () => void;
}

function FormExperienceHeader({
  title,
  rating = 5,
  nrOfReviews,
  experienceImage,
  localName,
  localImage,
  nrOfOtherLocals = 0,
  isLocalPicker,
  onBack,
}: FormExperienceHeaderProps) {
  const showMultipleLocals = !isLocalPicker && nrOfOtherLocals > 0;
  return (
    <header className={CSS.FormHeader}>
      {onBack && (
        <button onClick={onBack} className={CSS.BackButton}>
          <ChevronIcon
            height={14}
            width={14}
            className={CSS.BackButtonIcon}
            direction="left"
          />
        </button>
      )}
      <h2 className={CSS.Title}>Personalize your experience</h2>
      <div className={CSS.ExperienceCard}>
        <div className={CSS.ImagesContainer}>
          {experienceImage && (
            <Image
              className={CSS.ExperienceImage}
              height={IMAGE_OPTIONS.height}
              width={IMAGE_OPTIONS.width}
              options={IMAGE_OPTIONS}
              alt="Withlocals experience impression"
              src={experienceImage}
            />
          )}
          {!experienceImage && <div className={CSS.ExperienceImage} />}
          <figure className={CSS.LocalImageContainer}>
            {localImage && experienceImage && (
              <>
                <Image
                  className={CSS.LocalImage}
                  height={AVATAR_OPTIONS.height}
                  width={AVATAR_OPTIONS.width}
                  options={AVATAR_OPTIONS}
                  alt={`Withlocals host ${localName}`}
                  src={localImage}
                />
                {!isLocalPicker && nrOfOtherLocals > 0 && (
                  <span className={CSS.OtherCard}>+{nrOfOtherLocals}</span>
                )}
              </>
            )}
          </figure>
        </div>
        <div className={CSS.ExperienceDetails}>
          <div className={CSS.RatingContainer}>
            <span className={CSS.Rating}>
              <StarIcon size={12} className={CSS.StarIcon} />
              {Number(rating).toFixed(1)}
            </span>
            ({nrOfReviews} reviews)
          </div>
          <h3 className={CSS.ExperienceTitle}>{title}</h3>
          <p className={CSS.CardText}>
            <span className={CSS.Highlighted}>{localName}</span>
            {showMultipleLocals && (
              <>
                {' '}
                &{' '}
                <span className={CSS.Highlighted}>
                  {nrOfOtherLocals} other local{nrOfOtherLocals > 1 && 's'}
                </span>
              </>
            )}

            <br />
            <span>
              {showMultipleLocals ? 'are' : 'is'} open for your request
            </span>
          </p>
        </div>
      </div>
    </header>
  );
}

export default FormExperienceHeader;
